import { schemaQuerySnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '@/schema'

export const judicialPreanalysesQuery = () =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['judicialPreanalyses'],
    factory: collections.judicialPreanalyses,
    query: {
      name: 'All judicial pre-analyses',
    },
  })
